(function(){
  'use strict';
  angular.module("irricrops")

    //url de api
     .constant('urls', {
       BASE                 : 'https://api.irricrops.com',
       SELF                 : 'https://legacy.irricrops.com',
       PRODUCTION_HOST_NAME : 'legacy.irricrops.com',
       S3                   : 'https://s3-us-west-2.amazonaws.com/irricrops/'
     })

    //constantes generales
    .constant("CONSTANTES",{
      INITIAL_STATE  : "vinedo.newtimeline",
      INITIAL_MOBILE_STATE  : "vinedo.resumen",
      TOAST_POSITION : "top right",
      MODES          : {
        produccion: "altTheme",
        riego: "default"
      },
      RESPONSIVE:{
        xs: 600,
        sm: 960,
        md: 1280,
        lg: 1920
      },
      DIAS_SEMANA: [{
                      m: "Lunes",
                      l: "lunes",
                      s: "Lun",
                      x: "L"
                    },{
                      m: "Martes",
                      l: "martes",
                      s: "Mar",
                      x: "M"
                    },{
                      m: "Miércoles",
                      l: "miercoles",
                      s: "Mie",
                      x: "M'"
                    },{
                      m: "Jueves",
                      l: "jueves",
                      s: "Jue",
                      x: "J"
                    },{
                      m: "Viernes",
                      l: "viernes",
                      s: "Vie",
                      x: "V"
                    },{
                      m: "Sábado",
                      l: "sabado",
                      s: "Sa",
                      x: "S"
                    },{
                      m: "Domingo",
                      l: "domingo",
                      s: "Dom",
                      x: "D"
                    }]
    });

})();
